export const AppPermissions = {
  System: {
    Admin: 'System.Admin',
  },
  Apk: {
    Read: 'Apk.Read',
    Edit: 'Apk.Edit',
    Delete: 'Apk.Delete',
  },
  Export: {
    Read: 'Export.Read',
    Edit: 'Export.Edit',
    Delete: 'Export.Delete',
  },
  Contract: {
    Read: 'Contract.Read',
    Edit: 'Contract.Edit',
    Delete: 'Contract.Delete',
  },
  Device: {
    Read: 'Device.Read',
    Import: 'Device.Import',
  },
  SuperSentinel: {
    Import: 'SuperSentinel.Import',
    Manage: 'SuperSentinel.BulkActivation.Manage',
  },
  Equipment: {
    Read: 'Equipment.Read',
  },
  Log: {
    Authentication: {
      Read: 'Log.Authentication.Read',
    },
    Permission: {
      Read: 'Log.Permission.Read',
    },
    Reader: {
      Read: 'Log.Reader.Read',
    },
    HttpRequest: {
      Read: 'Log.HttpRequest.Read',
    },
    Pairing: {
      Read: 'Log.Pairing.Read',
    },
    ScanSession: {
      Read: 'Log.ScanSession.Read',
    },
  },
  SightingRaw: {
    Read: 'SightingRaw.Read',
  },
  SightingLatest: {
    Read: 'SightingLatest.Read',
  },
  SightingProcessed: {
    Read: 'SightingProcessed.Read',
  },
  Reader: {
    Read: 'Reader.Read',
    Edit: 'Reader.Edit',
    Delete: 'Reader.Delete',
    LockedLocation: {
      Edit: 'Reader.LockedLocation.Edit',
    },
    StrictLocationLogic: {
      Edit: 'Reader.StrictLocationLogic.Edit',
    },
    Contract: {
      Edit: 'Reader.Contract.Edit',
    },
    ReportInterval: {
      Edit: 'Reader.ReportInterval.Edit',
    },
    IntendedUse: {
      Edit: 'Reader.IntendedUse.Edit',
    },
  },
  Facility: {
    Read: 'Facility.Read',
    Edit: 'Facility.Edit',
    Delete: 'Facility.Delete',
  },
  Geofence: {
    Read: 'Geofence.Read',
    Edit: 'Geofence.Edit',
    Delete: 'Geofence.Delete',
  },
  ReaderReport: {
    Read: 'ReaderReport.Read',
    Manage: 'ReaderReport.Unpaired.Read',
  },
  Pairing: {
    Read: 'Pairing.Read',
    Edit: 'Pairing.Edit',
    Delete: 'Pairing.Delete',
    OverrideHealthCheck: 'Pairing.OverrideHealthCheck',
  },
  LucTransfer: {
    Read: 'LUC_Transfer.Read',
    Edit: 'LUC_Transfer.Edit',
    Delete: 'LUC_Transfer.Delete',
  },
  Setting: {
    Read: 'Setting.Read',
    Manage: 'Setting.Manage',
  },
  MobileApp: {
    Use: 'MobileApp.Use',
  },
  ScanSession: {
    Read: 'ScanSession.Read',
    Edit: 'ScanSession.Edit',
  },
  ScopeTemplate: {
    Read: 'ScopeTemplate.Read',
    Edit: 'ScopeTemplate.Edit',
    Delete: 'ScopeTemplate.Delete',
  },
  Station: {
    Read: 'Station.Read',
  },
  User: {
    Manage: 'User.Manage',
  },
  Visit: {
    Read: 'Visit.Read',
  },
  Comment: {
    Read: 'Comment.Read',
    Edit: 'Comment.Edit',
    Delete: 'Comment.Delete',
  },
  Label: {
    Edit: 'Label.Edit',
    Delete: 'Label.Delete',
  },
  StockDetails: {
    Read: 'StockDetails.Read',
    Edit: 'StockDetails.Edit',
  },
  TasksQueue: {
    Read: 'Task.Read',
    Edit: 'Task.Edit',
    EditStatus: 'Task.Status.Edit',
    EditAssignee: 'Task.Assignee.Edit',
  },
  Language: {
    Manage: 'Language.Manage',
  },
  Template: {
    Manage: 'Template.Manage',
  },
  Collections: {
    Read: 'Collect_Multiple.Read',
    Edit: 'Collect_Multiple.Edit',
  },
  WebApp: {
    Use: 'WebApp.Use',
  },
  Company: {
    Read: 'Company.Read',
    Edit: 'Company.Edit',
    Delete: 'Company.Delete',
    CompanyRelations: {
      Read: 'Company.Relation.Read',
      Edit: 'Company.Relation.Edit',
      Delete: 'Company.Relation.Delete',
    },
  },
  UserGuide: {
    Manage: 'Document.UserGuide.Manage',
  },
};
